<template>
  <div class="custom-loading" :style="customStyle">
    <div class="custom-indicator">
      <div class="custom-animation">
        <i class="fas fa-spinner fa-spin"></i>
        <span class="custom-dots">
          {{ notice }} <span>.</span><span>.</span><span>.</span>
        </span>
      </div>
      <button
        v-if="isShowCancel"
        class="btn btn-link custom-cancel"
        @click="cancel"
      >
        cancel
      </button>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Overlay',
  props: {
    notice: {
      type: String,
      default: 'loading',
    },
    customStyle: String,
  },
  data() {
    return {
      isShowCancel: false,
    }
  },
  mounted() {
    let $this = this
    this.isShowCancel = false
    setTimeout(() => {
      $this.isShowCancel = true
    }, 15000)
  },
  methods: {
    cancel() {
      this.$emit('cancel')
    },
  },
}
</script>
<style lang="scss" scoped>
@keyframes blink {
  /**
    * At the start of the animation the dot
    * has an opacity of .2
    */
  0% {
    opacity: 0.2;
  }
  /**
    * At 20% the dot is fully visible and
    * then fades out slowly
    */
  20% {
    opacity: 1;
  }
  /**
    * Until it reaches an opacity of .2 and
    * the animation can start again
    */
  100% {
    opacity: 0.2;
  }
}
.custom-loading {
  z-index: 9999;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.2);
  position: absolute;
  top: 0;
  left: 0;
}
.custom-indicator {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: rgb(255, 255, 255);
  color: rgb(0, 0, 0);
  height: 80px;
  width: 150px;
  padding: 15px;
  text-align: center;
  border-radius: 5px;
}
.custom-animation {
  text-align: left;
  padding-top: 10px;
  padding-left: 12px;
}
.custom-dots {
  margin-left: 5px;
  span {
    /**
     * Use the blink animation, which is defined above
     */
    animation-name: blink;
    /**
     * The animation should take 1.4 seconds
     */
    animation-duration: 1.4s;
    /**
     * It will repeat itself forever
     */
    animation-iteration-count: infinite;
    /**
     * This makes sure that the starting style (opacity: .2)
     * of the animation is applied before the animation starts.
     * Otherwise we would see a short flash or would have
     * to set the default styling of the dots to the same
     * as the animation. Same applies for the ending styles.
     */
    animation-fill-mode: both;
  }
  span:nth-child(2) {
    /**
     * Starts the animation of the third dot
     * with a delay of .2s, otherwise all dots
     * would animate at the same time
     */
    animation-delay: 0.2s;
  }
  span:nth-child(3) {
    /**
     * Starts the animation of the third dot
     * with a delay of .4s, otherwise all dots
     * would animate at the same time
     */
    animation-delay: 0.4s;
  }
}
.custom-cancel {
  font-size: 0.8em;
  bottom: 0;
  left: 45px;
  position: absolute;
}
</style>
